/* eslint-disable @typescript-eslint/no-explicit-any */
import { logEvent } from 'Helpers/analytics';
import useDoctor from 'Hooks/teleconsult/useDoctor';
import { useCallback } from 'react';

import useCalcualatorAIScore from './useCalcualatorAIScore';

interface IData {
  [key: string]: any;
}

const useAiCheckerLogEvent = (score?: number | string) => {
  const { data: doctor } = useDoctor();

  const { quality } = useCalcualatorAIScore(score);

  const logAICheckerEvent = useCallback(
    (event: string, data: IData) => {
      logEvent(event, {
        ...data,
        doctor_id: doctor?.id,
        item_id: score ?? '',
        category: quality ?? '',
      });
    },
    [doctor?.id, score, quality],
  );

  return { logAICheckerEvent };
};

export default useAiCheckerLogEvent;
